import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { Home } from 'lucide-react';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <Helmet>
        <title>Page Not Found | STOK</title>
        <meta name="description" content="Sorry, we couldn't find the page you're looking for." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <img 
            src="/logo.png" 
            alt="STOK Logo" 
            className="w-16 h-16 mx-auto rounded-lg"
          />
        </div>
        
        <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
        <h2 className="text-xl font-medium text-gray-700 mb-6">Page Not Found</h2>
        
        <p className="text-gray-600 mb-8">
          Sorry, we couldn't find the page you're looking for. It might have been moved or deleted.
        </p>
        
        <div className="flex flex-col space-y-3">
          <button 
            onClick={() => navigate('/')}
            className="flex items-center justify-center gap-2 bg-indigo-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-indigo-700 transition-colors"
          >
            <Home className="w-4 h-4" />
            <span>Go back home</span>
          </button>
          
          <button 
            onClick={() => navigate(-1)}
            className="text-indigo-600 hover:text-indigo-800 transition-colors"
          >
            Go back to previous page
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound; 